export default __webpack_public_path__ + "static/media/img (2).22173e04.jpg";